import React from "react";
import { Navigate } from "react-router-dom";
import { isTaAdmin } from "../../utils/adminAuth";

/**
 * Renders children only for platform ta-admin users.
 * Backend still enforces auth on admin APIs.
 */
const AdminRoute = ({ children }) => {
  if (!isTaAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default AdminRoute;
